export default "__VITE_ASSET__BvL0QWL$__"